module.exports = __webpack_public_path__ + "img/icon-warning-critical.4fd80762.svg";